import { Router, ActivatedRoute } from '@angular/router';
import { Output, EventEmitter, Component, OnInit, ViewChild } from '@angular/core';
import { SelfBillingAgreementService } from '../../services';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { UserService } from '../../services';
import { IUser } from '../../interfaces/user';
import { OrganisationsService } from '../../services';
import moment from 'moment';

@Component({
  selector: 'supplier-self-billing',
  templateUrl: './supplier-self-billing.component.html',
  styleUrls: ['./supplier-self-billing.component.scss'],
})
export class SupplierSelfBillingComponent implements OnInit {
  public backTo: string;
  agreeChecked: boolean;
  sendingCommit: boolean; //to block Agree button to avoid multiple requests
  currentUser: IUser;
  userOrg: any;
  agreementDate: Date;
  loading = true;

  constructor(
    public messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private selfBillingAgreementService: SelfBillingAgreementService,
    private userService: UserService,
    private orgService: OrganisationsService,
  ) {}

  async ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];
    this.currentUser = this.userService.currentUser;
    this.agreementDate = moment().add(1, 'year').toDate();

    this.orgService.getOrg(this.userService.currentUser.organisationId).then((userOrg) => {
      this.userOrg = userOrg;

      this.selfBillingAgreementService.getSelfBillingStatus().then((x) => {
        this.agreeChecked = x;
        this.loading = false;
      });
    });
  }

  goBack() {
    if (this.backTo) this.router.navigate([this.backTo]);
    else this.router.navigate(['/app']);
  }

  confirm(status) {
    this.sendingCommit = true;
    this.selfBillingAgreementService
      .commitSelfBillingStatus(status)
      .then(() => {
        this.goBack();
      })
      .catch(() => {
        this.sendingCommit = false;
        this.messageService.add(
          Message.Error(`Error updating the agreement`, 'Agreement updating'),
        );
      });
  }
}
